import {BATCH_ACTIONS, FINDER_DETAIL_SET_ADVANCED_SEARCH_OPTIONS} from '~/frontend/src/constants';
import setParam from '~/frontend/src/actions/panel/common/setParam';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';


type SetAdvancedSearchOptionsAction = {
    type : typeof FINDER_DETAIL_SET_ADVANCED_SEARCH_OPTIONS;
    subType : typeof BATCH_ACTIONS;
    panelKey : string;
    status : Status;
    timezone : string;
    timestamp : string;
    actions : any[];
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} status
 * @param {String} timezone
 * @param {String} timestamp
 *
 * @return {function}
 */
const setAdvancedSearchOptions = ( panelKey : string, status : Status, timezone : string, timestamp : string ) : SetAdvancedSearchOptionsAction => {
    return {
        type   : FINDER_DETAIL_SET_ADVANCED_SEARCH_OPTIONS,
        subType: BATCH_ACTIONS,
        panelKey,
        status,
        timezone,
        timestamp,
        actions: [
            setParam( panelKey, 'status', status ),
            setParam( panelKey, 'timezone', timezone ),
            setParam( panelKey, 'timestamp', timestamp ),
            clearElusiveData( panelKey )
        ]
    };
}
export type SetAdvancedSearchOptions = typeof setAdvancedSearchOptions;

export default setAdvancedSearchOptions;
